import { Checkbox, IFormRender } from '@busybusy/webapp-react-ui';
import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'i18next';
import { useState } from 'react';
import { useFeatureFlags } from 'utils/features';
import { ICreatePositionsFormData } from '../../forms/create-position-form/CreatePositionForm';

export const USE_KIOSK_PERMISSION_TITLE = t('Allow Kiosk Mode');
export const USE_KIOSK_PERMISSION_DESCRIPTION = t(
  'Allow the user to configure the mobile app to be used as an on-site kiosk.'
);

export interface IAllowKioskModeFormFieldsProps<T extends ICreatePositionsFormData> {
  form: IFormRender<T>;
}

interface IAllowKioskModeFormFieldsFormData {
  enabled: boolean;
}

function AllowKioskModeFormFields<T extends ICreatePositionsFormData>({ form }: IAllowKioskModeFormFieldsProps<T>) {
  const isUseKioskPermissionEnabled = useFeatureFlags('USE_KIOSK_PERMISSION');
  const [settings, setSettings] = useState<IAllowKioskModeFormFieldsFormData>(getInitialData());

  function getInitialData() {
    if (form.state.data.useKiosk) {
      return { enabled: true };
    } else {
      return { enabled: false };
    }
  }

  return (
    <ConditionalContainer condition={isUseKioskPermissionEnabled}>
      <Checkbox
        key={'enabled'}
        className="my-4"
        checked={settings.enabled}
        label={
          <HeaderText title={USE_KIOSK_PERMISSION_TITLE}>
            <span>{USE_KIOSK_PERMISSION_DESCRIPTION}</span>
          </HeaderText>
        }
        onChange={(value) => {
          setSettings({ enabled: value });
          form.state.data.useKiosk = value;
        }}
      />
    </ConditionalContainer>
  );
}

export default AllowKioskModeFormFields;
